import gql from 'graphql-tag';

export default gql`
query GetUser(
        $uuid: String!
        ) {
    getUsers(
        uuid: $uuid
    ) {
        uuid
        name
        desc
        year
        image
        langs
        rating
        reviews
    }
}
`;
